var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_641)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6667 31.8715H25.4329V20.9639C25.4329 17.9717 24.1129 16.3023 21.7456 16.3023C19.1695 16.3023 17.6407 18.0418 17.6407 20.9639V31.8715H11.4069V11.6117H17.6407V13.89C17.6407 13.89 19.5965 10.4581 24.0038 10.4581C28.4126 10.4581 31.6667 13.1485 31.6667 18.7153V31.8715ZM4.30355 8.37157C2.20121 8.37157 0.497833 6.65426 0.497833 4.53634C0.497833 2.41998 2.20121 0.702637 4.30355 0.702637C6.40433 0.702637 8.1077 2.41998 8.1077 4.53634C8.10925 6.65426 6.40433 8.37157 4.30355 8.37157ZM0.497833 31.8715H8.29004V11.6117H0.497833V31.8715Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.1688,
    height: 31.1688,
    fill: "white",
    transform: "translate(0.497833 0.702637)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.2d74548c45d6a2f6c5b2558a0c38d05d.svg";
export { ForwardRef as ReactComponent };